import {Drug} from "./drug";
import {Concept} from "./concept";
import {Criterion} from "./criterion";

export class CohortInfo {
  status: Concept;
  drugs: Drug[];

  constructor() {
    this.status = new Concept();
    this.status.code = "open";
    this.status.display = "Open";
    this.drugs = [];
  }
}
